type ExtendedWindow = Window &
  typeof globalThis & {
    cancelIdleCallback: (id: number) => void;
    requestIdleCallback: (cb: () => void) => number;
  };

export function requestIdleCallback(cb: () => void) {
  const extended = window as ExtendedWindow;
  return extended.requestIdleCallback
    ? extended.requestIdleCallback(cb)
    : extended.setTimeout(function () {
        cb();
      }, 1);
}
export function cancelIdleCallback(id: number) {
  const extended = window as ExtendedWindow;
  return extended.cancelIdleCallback ? extended.cancelIdleCallback(id) : clearTimeout(id);
}
